<template>
    <DModal
        :show="showModal"
        :title="title"
        is-big
        overflow-auto
        @close="closeModal"
    >
        <DRow>
            <DCol md="12">
                <DCard class="pt-0">
                    <DCardBody class="overflow-hidden">
                        <pdf
                            v-for="i in numPages"
                            :key="i"
                            :src="pdfSource"
                            :page="i"
                        />
                    </DCardBody>
                </DCard>
            </DCol>
        </DRow>
    </DModal>
</template>

<script setup>
import pdf from 'vue3-pdf'

defineProps({
    title: {
        type: String,
        default: ''
    },
    showModal: {
        type: Boolean,
        default: false
    },
    pdfSource: {
        type: String,
        default: ''
    },
    numPages: {
        type: Number,
        default: 1
    }
})
const emit = defineEmits(['confirm', 'close'])

const closeModal = () => emit('close')
</script>

<style lang="scss" scoped>
.overflow-hidden {
    overflow: hidden !important;
}
</style>
